<div class="kt-password-change__body">
	<div class="kt-login__form p-5">
		<img *ngIf="loginType === 'order-go'" class="kt-login_logo pb-5" src="/assets/media/homepage/logo_image.png" width="141" srcset="/assets/media/homepage/logo_image.png 1x, /assets/media/homepage/logo_image@2x.png 2x">
		<img *ngIf="loginType === 'suumo'" class="kt-login_logo pb-5" src="/assets/media/homepage/logo_suumo.jpg" width="225">
		<h1>パスワードを変更してください</h1>
		<form *ngIf="form" class="kt-form m-0" [formGroup]="form" autocomplete="off">
			<div class="row">
				<div class="form-group col-md-6">
					<label translate="MY_SETTINGS.PASSWORD_DETAIL.NEW_PASSWORD"></label>
					<mat-form-field
						appearance="fill"
						class="mat-form-field-fluid">
						<input
							matInput
							type="password"
							autocomplete="off"
							[placeholder]="'MY_SETTINGS.PASSWORD_DETAIL.NEW_PASSWORD' | translate"
							formControlName="newPassword" />
					</mat-form-field>
					<div *ngIf="isControlHasError('newPassword','required')" class="alert alert-danger">
						{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
					</div>
					<div *ngIf="isControlHasError('newPassword','minlength')" class="alert alert-danger">
						{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3
					</div>
					<div *ngIf="isControlHasError('newPassword','maxlength')" class="alert alert-danger">
						{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100
					</div>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-md-6">
					<label translate="MY_SETTINGS.PASSWORD_DETAIL.CONFIRM_PASSWORD"></label>
					<mat-form-field
						appearance="fill"
						class="mat-form-field-fluid">
						<input
							matInput
							type="password"
							autocomplete="off"
							[placeholder]="'MY_SETTINGS.PASSWORD_DETAIL.CONFIRM_PASSWORD'  | translate"
							formControlName="confirmPassword" />
					</mat-form-field>
					<div *ngIf="isControlHasError('confirmPassword','required')" class="alert alert-danger">
						{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
					</div>
					<div *ngIf="isControlHasError('confirmPassword','mustMatch')" class="alert alert-danger">
						{{ 'AUTH.VALIDATION.CONFIRM_PASSWORD_MUST_MATCH' | translate }}
					</div>
				</div>
			</div>
			<div class="kt-login__button pb-5">
				<button (click)="submit()" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}" id="kt_login_signin_submit" class="btn btn-primary btn-elevate kt-login__btn-primary">{{ 'MENU.SAVE' | translate }}</button>
			</div>
			<div *ngIf="currentUser != undefined" class="kt-login__button pb-5">
				<a role="button" (click)="logout()">ログアウト</a>
			</div>
			<div *ngIf="sent" class="d-flex flex-column align-items-center">
				<p>新しいパスワードが設定されました。ログインページからログインしてください。</p>
				<p><a [routerLink]="loginType === 'order-go' ? '/auth/login' : '/auth/suumo-login'">ログインページへ</a></p>
			</div>
		</form>
	</div>
</div>
